import { Facebook, Instagram } from 'lucide-react';
import { Link } from 'react-router-dom';

const PHONES = [
  { number: "+56 9 9997 3396", label: "Secretaría" },
  { number: "+56 9 8723 7809", label: "Recepción" },
  { number: "+56 9 9997 3482", label: "Inspectoría" },
];

const FOOTER_LINKS = [
  { to: "/quienes-somos", text: "Quiénes somos" },
  { to: "/becas", text: "Becas 2027" },
  { to: "/documentos", text: "Documentos" },
  { to: "/lista-de-utiles", text: "Lista de útiles" },
];

const SOCIAL_LINKS = [
  { href: "https://web.facebook.com/colegionmva", icon: Facebook, label: "Visitar nuestra página de Facebook" },
  { href: "https://www.instagram.com/colegionmva", icon: Instagram, label: "Visitar nuestra página de Instagram" },
];

const columnTitle = "mb-3 text-sm font-bold uppercase tracking-wider text-white";

// Pie de página al estilo nido.cl: bloque sólido con línea de acento, texto en mayúsculas y enlaces separados por barras
const Footer = () => {
  return (
    <footer className="w-full bg-green-900 text-white">
      <div className="h-1.5 w-full bg-accent" aria-hidden="true" />

      <div className="container mx-auto px-6 md:px-8 pt-12 pb-8">
        <div className="flex flex-col gap-8 md:flex-row md:items-start md:justify-between">
          <div>
            <h2 className="text-lg md:text-xl font-bold uppercase tracking-wide">
              © {new Date().getFullYear()} Colegio Nuevo Milenio
            </h2>
            <p className="mt-2 text-sm uppercase tracking-wide">
              Calle Alcalde Rodolfo Galleguillos, Número 197, Villa Alemana.
            </p>
            <p className="mt-1 text-sm uppercase tracking-wide">Lun a Vier: 8:00 - 13:30 Hrs</p>
            <p className="mt-1 text-sm">informaciones@nmva.cl</p>
          </div>

          <div className="flex items-center gap-6">
            <img
              src="/01-images/logo.webp"
              alt=""
              width={648}
              height={224}
              loading="lazy"
              className="hidden sm:block h-14 w-auto"
            />
            <div className="flex gap-3">
              {SOCIAL_LINKS.map((social) => {
                const Icon = social.icon;
                return (
                  <a
                    key={social.href}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={social.label}
                    className="flex h-10 w-10 items-center justify-center rounded-md bg-white text-green-900 transition-colors hover:bg-beige-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white"
                  >
                    <Icon className="h-5 w-5" aria-hidden="true" />
                  </a>
                );
              })}
            </div>
          </div>
        </div>

        <div className="mt-10 grid gap-8 border-t border-white/20 pt-8 sm:grid-cols-2">
          <div>
            <h3 className={columnTitle}>Teléfonos</h3>
            <ul className="space-y-1 text-sm">
              {PHONES.map((phone) => (
                <li key={phone.label}>{phone.number} {phone.label}</li>
              ))}
            </ul>
          </div>
          <div>
            <h3 className={columnTitle}>Datos bancarios</h3>
            <ul className="space-y-1 text-sm">
              <li>Cuenta Corriente Nro: 9747965-46</li>
              <li>Banco: Scotiabank Chile</li>
              <li>Rut: 65.154.531-5</li>
              <li>Fundación Educacional Nuevo Milenio</li>
              <li>recaudaciones@nmva.cl</li>
              <li>fono contacto: +56 9 8723 9659</li>
            </ul>
          </div>
        </div>

        <nav aria-label="Enlaces del pie de página" className="mt-10 flex flex-wrap items-center gap-y-2 text-sm uppercase tracking-wide">
          {FOOTER_LINKS.map((link, index) => (
            <span key={link.to} className="flex items-center">
              {index > 0 && <span className="mx-4 text-white/40" aria-hidden="true">|</span>}
              <Link to={link.to} className="hover:underline underline-offset-4">{link.text}</Link>
            </span>
          ))}
        </nav>

        <p className="mt-8 text-xs text-white/70">
          Página web desarrollada por{' '}
          <a
            href="https://integria.cl"
            target="_blank"
            rel="noopener noreferrer"
            className="font-bold hover:text-white hover:underline"
          >
            integrIA
          </a>
          <span className="mx-3 text-white/40" aria-hidden="true">|</span>
          Tour virtual por{' '}
          <a
            href="https://tourify.cl"
            target="_blank"
            rel="noopener noreferrer"
            className="font-bold hover:text-white hover:underline"
          >
            Tourify
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
